<template>
  <div id="app">
  <router-view/>
  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: 'app',
  mounted() {

    // 友盟统计添加
    const script = document.createElement("script");
    script.src =
        "https://s95.cnzz.com/z_stat.php?id=1277875016&web_id=1277875016";
    script.language = "JavaScript";
    document.body.appendChild(script);

  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);

      }
    }
  }
}
</script>

<style lang="less">
html,
body{
  margin: 0;
  padding: 0;

  background: #EFEFEF;
  color: #595959;
  .van-button--default{
    color: #595959;
  }
  .van-cell{
    color: #595959;
  }
}
#app {


  text-align: center;
  color: #595959;
  //margin-top: 60px;
  .van-dialog__header{
    font-weight: 600;
    font-size: 1.2em;
  }
  .van-dialog__content{
    font-weight: 400;

  }

}

.exchange_coupon {
  display: flex;
  align-items: center;
  position: relative;
  background: #FFF7F3;
  padding: 3vw;
  margin: 3vw;
  border-radius: 2vw;

  &:before {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    left: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  &:after {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    right: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  .yui_icon {
    width: 7vw;
    margin-right: 2vw;

    img {
      width: 100%;
    }
  }

  .coupon-info {
    flex: 1;

    h5 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #595959;
      line-height: 20px;
    }

    .y-link {

      font-size: 10px;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
      display: inline-flex;
      align-items: center;
    }
  }

  .yui_ft {
    width: 18vw;
    text-align: center;
    position: relative;

    &:before {
      position: absolute;
      content: " ";
      top: 2vw;
      left: 0;
      bottom: 2vw;
      border-left: 1px dashed #F4B18F60;
    //border-left-style:dashed;
    }

    p {
      margin: 0;

      font-size: 2.6vw;
      font-weight: 400;
      color: #2FBD4B;
      line-height: 1.6;
    }
  }
}

.yui_btn-exchange {
  padding-left: 2vw;
  padding-right: 2vw;
  background-color: transparent;
}

.y_cell-activity-code{
  .van-cell__title{
    align-items: center;
    display: inline-flex;
  }
}

</style>
